
import React from "react";
import { Button } from "@/components/ui/button";
import { XCircle, RotateCcw, RefreshCw } from "lucide-react";
import { ExpertApplication } from "@/types/admin";

interface RejectedApplicationActionsProps {
  application: ExpertApplication;
  onStatusUpdate: (applicationId: string, status: 'approved' | 'rejected') => void;
  loading: boolean;
}

export default function RejectedApplicationActions({ 
  application, 
  onStatusUpdate, 
  loading 
}: RejectedApplicationActionsProps) {
  return (
    <div className="space-y-3">
      <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
        <div className="flex items-center gap-2 text-red-800">
          <XCircle className="h-4 w-4" />
          <span className="text-sm font-medium">Application Rejected</span>
        </div>
        {application.reviewed_at && (
          <p className="text-xs text-red-600 mt-1">
            Rejected on {new Date(application.reviewed_at).toLocaleDateString()}
          </p>
        )}
      </div>
      
      <div className="space-y-2">
        <h4 className="font-medium text-sm">Reopen Options</h4>
        <Button
          onClick={() => onStatusUpdate(application.id, 'approved')}
          variant="outline"
          className="w-full justify-between"
          disabled={loading}
        >
          <span className="flex items-center gap-2">
            <RotateCcw className="h-4 w-4" />
            Reopen and Approve
          </span>
          <RefreshCw className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
